import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AUTO_SAVE_STATUS } from '@src/constants/project';

// Auto-save states where leaving/closing the tab risks losing work:
// SAVING (a request is in flight) and ERROR (a save failed and is retrying).
const BLOCKING_STATUSES = [AUTO_SAVE_STATUS.SAVING, AUTO_SAVE_STATUS.ERROR];

// Warns the user (native browser prompt) before they close/reload the tab while
// an auto-save is still in flight or failed. No-op unless `enabled`.
const useUnloadGuard = ({ enabled }) => {
  const autoSaveStatus = useSelector((s) => s.project.autoSaveStatus);

  useEffect(() => {
    if (!enabled || !BLOCKING_STATUSES.includes(autoSaveStatus)) {
      return undefined;
    }

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      // Modern browsers ignore custom text and show their own generic prompt;
      // a non-empty returnValue is what actually triggers the dialog.
      const e = event;
      e.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [enabled, autoSaveStatus]);
};

export default useUnloadGuard;
